/**
 * Walt Disney World Character Meet & Greets — dedicated/scheduled meets only.
 * Used for the Character Meet & Greets questionnaire section and backend-friendly reference.
 * DinoLand U.S.A. closed permanently on 2026-02-01; DinoLand-specific meet & greets are excluded.
 */
export const lastVerified = "2026-02-02";

export const charactersByPark = {
  "Magic Kingdom": [
    { park: "Magic Kingdom", area: "Main Street, U.S.A.", locationName: "Town Square Theater", characters: ["Mickey Mouse"], type: "dedicated", availability: "active", notes: "" },
    { park: "Magic Kingdom", area: "Main Street, U.S.A.", locationName: "Town Square Theater Porch", characters: ["Visiting Princess (rotates)"], type: "dedicated", availability: "active", notes: "Princess rotates; check schedule." },
    { park: "Magic Kingdom", area: "Fantasyland", locationName: "Princess Fairytale Hall", characters: ["Princesses (rotate)"], type: "dedicated", availability: "active", notes: "" },
    { park: "Magic Kingdom", area: "Fantasyland", locationName: "Ariel's Grotto", characters: ["Ariel"], type: "dedicated", availability: "active", notes: "" },
    { park: "Magic Kingdom", area: "Fantasyland", locationName: "The Thotful Spot", characters: ["Winnie the Pooh", "Tigger"], type: "dedicated", availability: "active", notes: "" },
    { park: "Magic Kingdom", area: "Fantasyland", locationName: "Fairytale Garden", characters: ["Mirabel"], type: "dedicated", availability: "active", notes: "" },
    { park: "Magic Kingdom", area: "Fantasyland", locationName: "Outside Peter Pan's Flight", characters: ["Peter Pan"], type: "dedicated", availability: "active", notes: "" },
    { park: "Magic Kingdom", area: "Fantasyland", locationName: "Storybook Circus / Pete's Silly Sideshow", characters: ["Minnie Mouse", "Daisy Duck", "Donald Duck", "Goofy"], type: "dedicated", availability: "active", notes: "Circus costumes." },
    { park: "Magic Kingdom", area: "Adventureland", locationName: "Agrabah Bazaar", characters: ["Aladdin", "Jasmine"], type: "dedicated", availability: "active", notes: "" },
    { park: "Magic Kingdom", area: "Adventureland", locationName: "Outside Plaza del Sol Caribe Bazaar", characters: ["Captain Jack Sparrow"], type: "dedicated", availability: "active", notes: "" },
    { park: "Magic Kingdom", area: "Tomorrowland", locationName: "Near Space Mountain", characters: ["Stitch"], type: "dedicated", availability: "active", notes: "" },
    { park: "Magic Kingdom", area: "Tomorrowland", locationName: "Buzz Lightyear exit courtyard", characters: ["Chip", "Dale"], type: "dedicated", availability: "active", notes: "" },
  ],
  "EPCOT": [
    { park: "EPCOT", area: "World Celebration", locationName: "CommuniCore Hall", characters: ["Mickey & Friends (varies)"], type: "dedicated", availability: "active", notes: "Lineup rotates; check schedule." },
    { park: "EPCOT", area: "World Celebration", locationName: "Imagination Pavilion", characters: ["Figment"], type: "dedicated", availability: "active", notes: "" },
    { park: "EPCOT", area: "World Discovery", locationName: "Near Guardians of the Galaxy: Cosmic Rewind", characters: ["Star-Lord"], type: "dedicated", availability: "active", notes: "" },
    { park: "EPCOT", area: "World Nature", locationName: "Near Journey of Water entrance", characters: ["Moana"], type: "dedicated", availability: "active", notes: "" },
    { park: "EPCOT", area: "World Showcase", locationName: "Mexico Pavilion", characters: ["Donald Duck"], type: "dedicated", availability: "active", notes: "" },
    { park: "EPCOT", area: "World Showcase", locationName: "Royal Sommerhus, Norway Pavilion", characters: ["Anna", "Elsa"], type: "dedicated", availability: "active", notes: "" },
    { park: "EPCOT", area: "World Showcase", locationName: "China Pavilion", characters: ["Mulan"], type: "dedicated", availability: "active", notes: "" },
    { park: "EPCOT", area: "World Showcase", locationName: "Germany Pavilion", characters: ["Snow White"], type: "dedicated", availability: "active", notes: "" },
    { park: "EPCOT", area: "World Showcase", locationName: "Morocco Pavilion", characters: ["Jasmine"], type: "dedicated", availability: "active", notes: "" },
    { park: "EPCOT", area: "World Showcase", locationName: "France Pavilion", characters: ["Belle"], type: "dedicated", availability: "active", notes: "" },
    { park: "EPCOT", area: "World Showcase", locationName: "France Pavilion", characters: ["Aurora"], type: "dedicated", availability: "active", notes: "" },
    { park: "EPCOT", area: "World Showcase", locationName: "English Gardens, UK Pavilion", characters: ["Alice"], type: "dedicated", availability: "active", notes: "" },
    { park: "EPCOT", area: "World Showcase", locationName: "English Gardens, UK Pavilion", characters: ["Mary Poppins"], type: "dedicated", availability: "active", notes: "" },
    { park: "EPCOT", area: "World Showcase", locationName: "UK Pavilion", characters: ["Winnie the Pooh"], type: "dedicated", availability: "active", notes: "" },
    { park: "EPCOT", area: "World Showcase", locationName: "World Showcase Plaza Gazebo", characters: ["Asha"], type: "dedicated", availability: "active", notes: "" },
  ],
  "Hollywood Studios": [
    { park: "Hollywood Studios", area: "Commissary Lane", locationName: "Red Carpet Dreams", characters: ["Mickey Mouse", "Minnie Mouse"], type: "dedicated", availability: "active", notes: "" },
    { park: "Hollywood Studios", area: "Commissary Lane", locationName: "Celebrity Spotlight", characters: ["Olaf"], type: "dedicated", availability: "active", notes: "" },
    { park: "Hollywood Studios", area: "Echo Lake", locationName: "Star Tours area", characters: ["Darth Vader"], type: "dedicated", availability: "active", notes: "" },
    { park: "Hollywood Studios", area: "Echo Lake", locationName: "Echo Lake", characters: ["Daisy Duck"], type: "dedicated", availability: "active", notes: "" },
    { park: "Hollywood Studios", area: "Echo Lake", locationName: "Echo Lake", characters: ["Donald Duck"], type: "dedicated", availability: "active", notes: "" },
    { park: "Hollywood Studios", area: "Grand Avenue", locationName: "Grand Avenue", characters: ["Goofy", "Max", "Pluto"], type: "dedicated", availability: "active", notes: "" },
    { park: "Hollywood Studios", area: "Hollywood Boulevard", locationName: "Near The Hollywood Brown Derby", characters: ["Chip", "Dale"], type: "dedicated", availability: "active", notes: "" },
    { park: "Hollywood Studios", area: "Hollywood Boulevard", locationName: "Near Mickey & Minnie's Runaway Railway", characters: ["Mary Poppins", "Bert", "Pinocchio", "Jiminy Cricket"], type: "dedicated", availability: "active", notes: "Lineup may vary; check schedule." },
    { park: "Hollywood Studios", area: "Animation Courtyard", locationName: "Walt Disney Presents", characters: ["Ariel (live-action)"], type: "dedicated", availability: "active", notes: "" },
    { park: "Hollywood Studios", area: "Pixar Plaza", locationName: "Pixar Plaza", characters: ["Edna Mode"], type: "dedicated", availability: "active", notes: "" },
    { park: "Hollywood Studios", area: "Pixar Plaza", locationName: "Pixar Plaza", characters: ["Mr. Incredible", "Mrs. Incredible"], type: "dedicated", availability: "active", notes: "" },
    { park: "Hollywood Studios", area: "Pixar Plaza", locationName: "Pixar Plaza", characters: ["Sulley", "Joy"], type: "dedicated", availability: "active", notes: "" },
    { park: "Hollywood Studios", area: "Toy Story Land", locationName: "Toy Story Land", characters: ["Buzz Lightyear", "Woody", "Jessie", "Bo Peep"], type: "dedicated", availability: "active", notes: "" },
  ],
  // DinoLand U.S.A. closed permanently on 2026-02-01; DinoLand-specific meet & greets (e.g., Donald's Dino-Bash) are not included.
  "Animal Kingdom": [
    { park: "Animal Kingdom", area: "Discovery Island", locationName: "Adventurers Outpost", characters: ["Mickey Mouse", "Minnie Mouse"], type: "dedicated", availability: "active", notes: "" },
    { park: "Animal Kingdom", area: "Discovery Island", locationName: "Discovery Island", characters: ["Nick Wilde", "Judy Hopps"], type: "dedicated", availability: "active", notes: "" },
    { park: "Animal Kingdom", area: "Discovery Island", locationName: "Discovery Island", characters: ["Moana"], type: "dedicated", availability: "active", notes: "" },
    { park: "Animal Kingdom", area: "Discovery Island", locationName: "Discovery Island", characters: ["Pocahontas"], type: "dedicated", availability: "active", notes: "" },
    { park: "Animal Kingdom", area: "Discovery Island", locationName: "Discovery Island", characters: ["Russell", "Dug"], type: "dedicated", availability: "active", notes: "" },
    { park: "Animal Kingdom", area: "The Oasis", locationName: "The Oasis", characters: ["Pluto"], type: "dedicated", availability: "active", notes: "" },
    { park: "Animal Kingdom", area: "Rafiki's Planet Watch", locationName: "Rafiki's Planet Watch", characters: ["Timon"], type: "dedicated", availability: "active", notes: "" },
    { park: "Animal Kingdom", area: "Rafiki's Planet Watch", locationName: "Rafiki's Planet Watch", characters: ["Rafiki"], type: "dedicated", availability: "active", notes: "" },
  ],
};

/**
 * Flat list of character names for the questionnaire (derived from charactersByPark).
 * Used as fallback when no parks are selected; otherwise use getCharacterOptionsForParks(selectedParks).
 */
const allCharacterNames = [...Object.values(charactersByPark)].flatMap((entries) =>
  entries.flatMap((e) => e.characters)
);
const uniqueNames = [...new Set(allCharacterNames)].filter(Boolean).sort();
export const characterMeetGreetOptions = [...uniqueNames, "Other"];

/**
 * Optional categorization for display (e.g. group by "Classic", "Princesses", "Pixar").
 * Not every character is categorized; uncategorized appear under "Other characters".
 */
export const CHARACTER_CATEGORIES = {
  Classic: [
    "Mickey Mouse", "Minnie Mouse", "Donald Duck", "Daisy Duck", "Goofy", "Pluto",
    "Chip", "Dale", "Figment", "Mickey & Friends (varies)",
  ],
  Princesses: [
    "Ariel", "Ariel (live-action)", "Aurora", "Belle", "Elsa", "Anna", "Jasmine", "Mulan", "Moana",
    "Snow White", "Pocahontas", "Mirabel", "Asha",
    "Visiting Princess (rotates)", "Princesses (rotate)",
  ],
  Pixar: [
    "Buzz Lightyear", "Woody", "Jessie", "Bo Peep", "Edna Mode", "Mr. Incredible",
    "Mrs. Incredible", "Sulley", "Joy", "Russell", "Dug", "Nick Wilde", "Judy Hopps",
  ],
  "Disney Films & More": [
    "Peter Pan", "Winnie the Pooh", "Tigger", "Mary Poppins", "Alice", "Olaf",
    "Stitch", "Captain Jack Sparrow", "Aladdin", "Star-Lord", "Darth Vader",
    "Rafiki", "Timon", "Bert", "Pinocchio", "Jiminy Cricket", "Max",
  ],
};

/**
 * Returns a unique, sorted list of character names available at the given parks,
 * plus "Other". Use for questionnaire options so only characters at selected parks are shown.
 * @param {string[]} selectedParks - Park names (e.g. ["Magic Kingdom", "EPCOT"])
 * @returns {string[]}
 */
export function getCharacterOptionsForParks(selectedParks) {
  if (!Array.isArray(selectedParks) || selectedParks.length === 0) return [];
  const names = new Set();
  for (const park of selectedParks) {
    const entries = charactersByPark[park];
    if (entries) {
      for (const entry of entries) {
        for (const name of entry.characters || []) {
          if (name) names.add(name);
        }
      }
    }
  }
  return [...names].sort((a, b) => a.localeCompare(b)).concat("Other");
}

/**
 * Returns character options for selected parks, grouped by category for display.
 * @param {string[]} selectedParks
 * @returns {{ [category: string]: string[] }}
 */
export function getCharacterOptionsForParksGrouped(selectedParks) {
  const flat = getCharacterOptionsForParks(selectedParks).filter((c) => c !== "Other");
  const grouped = {};
  const used = new Set();
  for (const [category, list] of Object.entries(CHARACTER_CATEGORIES)) {
    const inParks = list.filter((name) => flat.includes(name));
    if (inParks.length) {
      grouped[category] = inParks.sort((a, b) => a.localeCompare(b));
      inParks.forEach((n) => used.add(n));
    }
  }
  const uncategorized = flat.filter((n) => !used.has(n)).sort((a, b) => a.localeCompare(b));
  if (flat.length > 0) {
    grouped["Other characters"] = [...uncategorized, "Other"].sort((a, b) => (a === "Other" ? 1 : b === "Other" ? -1 : a.localeCompare(b)));
  }
  return grouped;
}

/**
 * Groups selected character names by category for recap modal display.
 * @param {string[]} selectedNames - Flat list of selected character names (e.g. from mustMeetCharacters)
 * @returns {{ [category: string]: string[] }}
 */
export function groupSelectedCharactersByCategory(selectedNames) {
  if (!Array.isArray(selectedNames) || selectedNames.length === 0) return {};
  const result = {};
  const used = new Set();
  for (const [category, list] of Object.entries(CHARACTER_CATEGORIES)) {
    const inSelection = list.filter((name) => selectedNames.includes(name));
    if (inSelection.length) {
      result[category] = inSelection.sort((a, b) => a.localeCompare(b));
      inSelection.forEach((n) => used.add(n));
    }
  }
  const uncategorized = selectedNames.filter((n) => !used.has(n) && n !== "Other");
  if (selectedNames.includes("Other")) uncategorized.push("Other");
  if (uncategorized.length) {
    result["Other characters"] = uncategorized.sort((a, b) =>
      a === "Other" ? 1 : b === "Other" ? -1 : a.localeCompare(b)
    );
  }
  return result;
}
